import { ref } from 'vue'
import { apiAtividadeConsolidada } from '@/services/atividadeConsolidada'
import { useAlert } from '@/composables/useAlert'
import { defineStore } from 'pinia'

export const useAtividadeConsolidada = defineStore('useAtividadeConsolidada', () => {
  const { alertError } = useAlert()
  const { obter, obterDetalhes, registrar, desconsiderar, editar, obterPorId } = apiAtividadeConsolidada()

  const loadingAtividades = ref(false)
  const atividades = ref(null)
  const atividadesDetalhes = ref(null)
  const atividadePorId = ref(null)

  const obterAtividades = async (params) => {
    try {
      loadingAtividades.value = true
      const resposta = await obter(params)
      atividades.value = resposta
    } catch (error) {
      atividades.value = null
    } finally {
      loadingAtividades.value = false
    }
  }

  const obterDetalhesAtividades = async (params) => {
    try {
      const resposta = await obterDetalhes(params)
      atividadesDetalhes.value = resposta
    } catch (error) {
      atividadesDetalhes.value = null
    }
  }

  const registrarAtividade = async (payload) => await registrar(payload)

  const obterAtividadePorId = async (id) => {
    try {
      const resposta = await obterPorId(id)
      atividadePorId.value = resposta
    } catch (error) {
      atividadePorId.value = null
    }
  }

  const editarAtividade = async (payload) => await editar(payload)

  const desconsiderarAtividade = async (payload) => await desconsiderar(payload)

  return {
    atividadePorId,
    atividadesDetalhes,
    desconsiderarAtividade,
    desconsiderarAtividade,
    editarAtividade,
    obterAtividadePorId,
    obterAtividades,
    registrarAtividade,
    obterDetalhesAtividades,
    loadingAtividades,
    atividades
  }
})
